<div [ngClass]="{'card-grid': !host, 'card-grid-journal': host}" *ngIf="display === 'grid'">
  <a [href]="getNewPostUrl()" class="create-section card-grid-item no-decor" *ngIf="showCreate">
    <div fxLayout="column" class="width-100" fxLayoutAlign="center center">
      <i class="icon-add width-100 margin-top-2 text-center"></i>
      <ng-container *ngIf="host === 'organization'; else elseTemplate">
        <p class="font-md sparro-grey-900 margin-top-2 font-bold">Create a journal</p>
      </ng-container>
      <ng-template #elseTemplate>
        <p class="font-md sparro-grey-900 font-bold">Upload new journal</p>
      </ng-template>
    </div>
  </a>

  <ng-container *ngIf="blogs">
    <div *ngFor="let blog of blogs" class="card-grid-item margin-4">
      <uni-blog-card
        class="card-grid-item"
        [blog]="blog"
        [self]="self"
        [host]="host"
        [user]="user"
        [dialogOpenable]="dialogOpenable"
        [featured]="host == 'blog' ? blog.featured : false"
        (removed)="removedBlog($event)"
        [showCardOptions]="showCardOptions">
      </uni-blog-card>
    </div>
  </ng-container>
</div>
